<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">{{
                $t("sectionTrocarSenha.trocarSenha")
              }}</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>{{ $t("textObrigatorios") }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionTrocarSenha.senhaAtual") }}</label
                    >
                    <input
                      v-model="viewModel.senha"
                      class="form-control"
                      maxlength="35"
                      type="password"
                      placeholder="Digite senha"
                      required
                      @paste.prevent
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionTrocarSenha.novaSenha") }}</label
                    >
                    <input
                      v-model="viewModel.novaSenha"
                      class="form-control"
                      maxlength="35"
                      type="password"
                      :placeholder="$t('sectionTrocarSenha.novaSenha')"
                      required
                      @paste.prevent
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >*
                      {{ $t("sectionTrocarSenha.confirmarNovaSenha") }}</label
                    >
                    <input
                      v-model="viewModel.confirmarSenha"
                      class="form-control"
                      maxlength="35"
                      type="password"
                      :placeholder="$t('sectionTrocarSenha.novaSenha')"
                      required
                      @paste.prevent
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-success mr-2" type="submit">
            {{ $t("btSalvar") }}
          </button>
          <button
            class="btn btn-secondary"
            type="reset"
            @click="$router.push('/')"
          >
            Voltar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "NovoUsuario",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      contaOptions: [],
      viewModel: {
        novaSenha: "",
        confirmarSenha: "",
        senha: "",
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        usuarioId: this.$store.getters.getAutenticacao.usuarioId
      }
    };
  },
  methods: {
    onPaste(evt) {},
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.viewModel.novaSenha !== this.viewModel.confirmarSenha) {
        const sectionTrocarSenha = this.$t(
          "sectionTrocarSenha.senhaNaoConfere"
        );

        this.$notify({
          data: [sectionTrocarSenha],
          type: "warn",
          duration: 10000
        });
      } else {
        this.Trocar();
      }
    },
    Trocar() {
      this.loading = true;
      this.$http({
        url: "usuario/trocar-senha",
        data: this.viewModel,
        method: "POST"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/");

          const senhaAlteradaComSucesso = this.$t(
            "sectionTrocarSenha.senhaAlteradaComSucesso"
          );

          this.$notify({
            data: [senhaAlteradaComSucesso],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
